// Copyright (c) Docugami, Inc. All rights reserved.

export interface UpgradeModalDisplayProps {
    visible: boolean;
    title: string;
    subText: string;
}

export interface DisplayState {
    navigationBarVisible: boolean;
    upgradeModalDisplayProps: UpgradeModalDisplayProps;
}

export const SET_UPGRADE_ACCOUNT_MODAL_VISIBILITY = "SET_UPGRADE_ACCOUNT_MODAL_VISIBILITY";
export const SET_NAVIGATION_BAR_VISIBILITY = "SET_NAVIGATION_BAR_VISIBILITY";
export const SET_UPGRADE_MODAL_DISPLAY_PROPS = "SET_UPGRADE_MODAL_DISPLAY_PROPS";

interface SetUpgradeAccountModalVisibility {
    type: typeof SET_UPGRADE_ACCOUNT_MODAL_VISIBILITY;
    payload: boolean;
}

interface SetNavigationBarVisibility {
    type: typeof SET_NAVIGATION_BAR_VISIBILITY;
    payload: boolean;
}

interface SetUpgradeModalDisplayProps {
    type: typeof SET_UPGRADE_MODAL_DISPLAY_PROPS;
    payload: UpgradeModalDisplayProps;
}

export type DisplayActionTypes = 
    SetUpgradeAccountModalVisibility |
    SetNavigationBarVisibility |
    SetUpgradeModalDisplayProps;
